// Module
var code = "<div class=\"MxPopover\" ng-bind-html=\"MxPopover.content\"></div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/tooltips/mxPopover/mxPopover.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;